const pinSvg = ({ color, glyph, accent = '#ffffff' }) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 56">
  <filter id="shadow" x="-20%" y="-20%" width="140%" height="150%">
    <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="#0f172a" flood-opacity="0.22"/>
  </filter>
  <path filter="url(#shadow)" d="M24 54c-1.8-3.6-5.4-7.8-9.2-12C9.4 36.1 5 30.3 5 21.9 5 10.9 13.5 3 24 3s19 7.9 19 18.9c0 8.4-4.4 14.2-9.8 20.1-3.8 4.2-7.4 8.4-9.2 12Z" fill="${color}"/>
  <circle cx="24" cy="22" r="15" fill="rgba(255,255,255,0.14)" stroke="rgba(255,255,255,0.76)" stroke-width="1.5"/>
  <g fill="none" stroke="${accent}" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
    ${glyph}
  </g>
</svg>`.trim()

export const MAP_MARKER_ICONS = {
  substation: pinSvg({
    color: '#2563eb',
    glyph: '<path d="M15 29h18"/><path d="M18 25l6-10 6 10"/><path d="M19 29l-3 7"/><path d="M29 29l3 7"/><path d="M21 25h6"/><path d="M24 15v-5"/>'
  }),
  'power-plant': pinSvg({
    color: '#7c3aed',
    glyph: '<path d="M14 33V21l7 4v-4l7 4v-8h6v16H14Z"/><path d="M21 33v-4"/><path d="M27 33v-4"/><path d="M32 14h4"/><path d="M18 17l4-6h-4l4-6"/>'
  }),
  'data-center': pinSvg({
    color: '#9333ea',
    glyph: '<rect x="15" y="11" width="18" height="24" rx="2"/><path d="M19 17h10"/><path d="M19 23h10"/><path d="M19 29h10"/><path d="M17 17h.1"/><path d="M17 23h.1"/><path d="M17 29h.1"/>'
  }),
  queue: pinSvg({
    color: '#db2777',
    glyph: '<path d="M14 18h12"/><path d="M14 26h20"/><path d="M14 34h14"/><path d="M31 15l4 4-4 4"/><path d="M29 31l4 4-4 4"/>'
  }),
  'gas-compressor': pinSvg({
    color: '#b45309',
    glyph: '<circle cx="24" cy="23" r="8"/><path d="M24 15v-6"/><path d="M24 37v-6"/><path d="M16 23h-6"/><path d="M38 23h-6"/><path d="M24 23l5-5"/><path d="M24 23l-6 2"/><path d="M24 23l3 6"/>'
  }),
  lng: pinSvg({
    color: '#0891b2',
    glyph: '<path d="M15 31V17c0-3 18-3 18 0v14c0 3-18 3-18 0Z"/><path d="M15 17c0 3 18 3 18 0"/><path d="M19 24h10"/><path d="M24 13v-5"/><path d="M21 10l3 3 3-3"/>'
  }),
  'gas-storage': pinSvg({
    color: '#78350f',
    glyph: '<path d="M15 31c3-4 6-6 9-6s6 2 9 6"/><path d="M16 34h16"/><path d="M18 27V15h12v12"/><path d="M21 19h6"/>'
  }),
  water: pinSvg({
    color: '#0ea5e9',
    glyph: '<path d="M24 10c5 6 9 11 9 16a9 9 0 0 1-18 0c0-5 4-10 9-16Z"/><path d="M17 35c3-2 5-2 8 0s5 2 8 0"/>'
  }),
  dam: pinSvg({
    color: '#2563eb',
    glyph: '<path d="M15 14h18v18"/><path d="M19 14v18"/><path d="M23 14v18"/><path d="M27 14v18"/><path d="M14 36c3-2 5-2 8 0s5 2 8 0 5 2 8 0"/>'
  }),
  freight: pinSvg({
    color: '#475569',
    glyph: '<path d="M12 28h19v-9h-7"/><path d="M31 23h4l3 5v4h-7"/><path d="M18 32a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"/><path d="M33 32a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"/><path d="M12 16h11"/><path d="M14 21h7"/>'
  }),
  environmental: pinSvg({
    color: '#dc2626',
    glyph: '<path d="M24 10 36 34H12L24 10Z"/><path d="M24 18v7"/><path d="M24 31h.1"/>'
  }),
  parcel: pinSvg({
    color: '#a855f7',
    glyph: '<path d="M14 16 25 11l9 5v17l-11 4-9-5V16Z"/><path d="M25 11v17"/><path d="M14 16l9 5 11-5"/><path d="M23 38V21"/>'
  }),
  utility: pinSvg({
    color: '#16a34a',
    glyph: '<path d="M15 29h18"/><path d="M18 25l6-10 6 10"/><path d="M19 29l-3 7"/><path d="M29 29l3 7"/><path d="M13 14c7-5 15-5 22 0"/><path d="M16 18c5-3 11-3 16 0"/>'
  })
}

export const LAYER_MARKER_ICONS = {
  electric_substations_hifld: 'substation',
  electric_substations_cached: 'substation',
  power_plants_hifld: 'power-plant',
  data_center_sites: 'data-center',
  operational_data_centers: 'data-center',
  interconnection_queue_projects: 'queue',
  interconnection_queue_county_summaries: 'queue',
  lng_terminals_eia: 'lng',
  gas_compressor_stations_hifld: 'gas-compressor',
  gas_processing_plants_hifld: 'gas-compressor',
  gas_storage_hifld: 'gas-storage',
  epa_echo_facilities: 'environmental',
  usace_national_inventory_dams: 'dam',
  ntad_intermodal_rail_facilities: 'freight',
  ntad_faf_network_nodes: 'freight',
  ntad_commercial_airports: 'freight'
}

export const markerIconKeyForLayer = (layer) => layer?.style?.markerIcon || LAYER_MARKER_ICONS[layer?.key]
export const markerIconImageName = (iconKey) => `landport-marker-${iconKey}`
export const markerIconImageNameForLayer = (layer) => {
  const iconKey = markerIconKeyForLayer(layer)
  return iconKey ? markerIconImageName(iconKey) : null
}
export const layerUsesMarkerIcon = (layer) => Boolean(markerIconKeyForLayer(layer) && MAP_MARKER_ICONS[markerIconKeyForLayer(layer)])

export const markerIconDataUrl = (svg) => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`

export const markerIconSizeExpression = (layer = {}) => (
  layer.style?.markerIconSize || [
    'interpolate',
    ['linear'],
    ['zoom'],
    4,
    0.42,
    8,
    0.56,
    12,
    0.72
  ]
)

export const registerMapMarkerIcons = async (map) => {
  if (!map) return

  await Promise.all(Object.entries(MAP_MARKER_ICONS).map(async ([iconKey, svg]) => {
    const imageName = markerIconImageName(iconKey)
    if (map.hasImage?.(imageName)) return

    const image = await imageFromSvg(svg)
    map.addImage(imageName, image, { pixelRatio: 2 })
  }))
}

const imageFromSvg = (svg) => new Promise((resolve, reject) => {
  const image = new Image(48, 56)
  image.onload = () => resolve(image)
  image.onerror = reject
  image.src = markerIconDataUrl(svg)
})
